import { Reducer } from 'redux';
import { SysAdminUserActionTypes, SysAdminUserState } from './types';
import { SysAdminOrgActionTypes } from '../../sysAdminOrg/localStore/types';

export const initialState: SysAdminUserState = {
  getUsersStatus: 'initial',
  getUserDetailsStatus: 'initial',
  createOrgsStatus: 'initial',
  getOrgGroupsStatus: 'initial',
  organisationGroups: [],
  reloadTrigger: 0
};

const reducer: Reducer<SysAdminUserState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SysAdminUserActionTypes.GET_USERS_START:
      return {
        ...state,
        getUsersStatus: 'fetching'
      };
    case SysAdminUserActionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        getUsersStatus: 'success',
        users: action.payload
      };
    case SysAdminUserActionTypes.GET_USERS_FAILURE:
      return {
        ...state,
        getUsersStatus: 'failed'
      };
    case SysAdminUserActionTypes.GET_USERS_RESET:
      return {
        ...state,
        getUsersStatus: 'initial'
      };
    case SysAdminUserActionTypes.GET_USER_DETAILS_START:
      return {
        ...state,
        getUserDetailsStatus: 'fetching'
      };
    case SysAdminUserActionTypes.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        getUserDetailsStatus: 'success',
        userDetails: action.payload
      };
    case SysAdminUserActionTypes.GET_USER_DETAILS_FAILURE:
      return {
        ...state,
        getUserDetailsStatus: 'failed'
      };
    case SysAdminUserActionTypes.GET_USER_DETAILS_RESET:
      return {
        ...state,
        getUserDetailsStatus: 'initial'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_START:
      return {
        ...state,
        getOrgGroupsStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_SUCCESS:
      return {
        ...state,
        getOrgGroupsStatus: 'success',
        organisationGroups: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_FAILURE:
      return {
        ...state,
        getOrgGroupsStatus: 'failed'
      };
    case SysAdminUserActionTypes.FREE_PLAN_UPGRADE_START:
      return {
        ...state,
        createOrgsStatus: 'creating'
      };
    case SysAdminUserActionTypes.FREE_PLAN_UPGRADE_SUCCESS:
      return {
        ...state,
        createOrgsStatus: 'success',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminUserActionTypes.FREE_PLAN_UPGRADE_FAILURE:
      return {
        ...state,
        createOrgsStatus: 'failed',
        createOrgsError: action.payload,
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminUserActionTypes.FREE_PLAN_UPGRADE_RESET:
      return {
        ...state,
        createOrgsStatus: 'initial',
        createOrgsError: undefined
      };
    default:
      return state;
  }
};

export default reducer;
